import { graphql } from "msw";
import messages from "../data/messaging/messages";

export const handlers = [
  graphql.query("getEntityMessages", (req, res, ctx) => {
    return res(
      ctx.data({
        getEntityMessages: messages,
        entityConversation: {
          id: "60476cdfd6a5e01ffa65706c",
          members: [
            {
              user: {
                displayName: "Panos Karvelas",
              },
            },
            {
              user: {
                displayName: "Naman Anand",
              },
            },
          ],
        },
      })
    );
  }),

  graphql.mutation("createMessage", (req, res, ctx) => {
    const { entityId, entityType, body } = req.variables; // eslint-disable-line no-unused-vars
    return res(
      ctx.data({
        message: "Updated Successfully",
        createMessage: {
          id: "603dd86a7498435f3f11d73a",
          body: body,
          sendAt: "2021-03-02T06:17:14",
          from: {
            id: "e10636@isdb.onmicrosoft.com",
            displayName: "Naman Anand",
            emailAddress: "e10636@isdb.onmicrosoft.com",
            country: null,
            organization: null,
            jobTitle: null,
            telephone: null,
          },
        },
      })
      // Simulate a server error
      // ctx.status(500),
      // ctx.errors({
      //   message: "Message not sent. Server Error.",
      // })
    );
  }),
  graphql.mutation("createConversation", (req, res, ctx) => {
    const { entityId, entityType, members } = req.variables; // eslint-disable-line no-unused-vars
    return res(
      ctx.data({
        createConversation: {
          entityId: "APZ12G4",
          entityType: "WithdrawalApplication",
          id: "60476fb2d6a5e01ffa65706d",
          members: [
            {
              notifications: "Mention",
              user: {
                id: "e10637@isdb.onmicrosoft.com",
              },
            },
            {
              notifications: "Mention",
              user: {
                id: "e10636@isdb.onmicrosoft.com",
              },
            },
          ],
        },
      })
    );
  }),

  graphql.mutation("entityConversation", (req, res, ctx) => {
    const { entityId, entityType } = req.variables; // eslint-disable-line no-unused-vars
    return res(
      ctx.data({
        entityConversation: {
          id: "60476cdfd6a5e01ffa65706c",
          members: [
            {
              user: {
                displayName: "Panos Karvelas",
              },
            },
            {
              user: {
                displayName: "Naman Anand",
              },
            },
          ],
        },
      })
    );
  }),

  graphql.mutation("addMemberToConversation", (req, res, ctx) => {
    const { conversationId, notifications, userId } = req.variables; // eslint-disable-line no-unused-vars
    return res(
      ctx.data({
        addMemberToConversation: {
          notifications: "Mention",
          user: {
            displayName: "Panos Karvelas",
            emailAddress: "e10637@isdb.onmicrosoft.com",
          },
        },
      })
    );
  }),

  graphql.mutation("removeMemberFromConversation", (req, res, ctx) => {
    const { conversationId, notifications, userId } = req.variables; // eslint-disable-line no-unused-vars
    return res(
      ctx.data({
        removeMemberFromConversation: {
          success: true,
        },
      })
    );
  }),

  graphql.mutation("updateMemberToConversation", (req, res, ctx) => {
    const { conversationId, notifications, userId } = req.variables; // eslint-disable-line no-unused-vars
    return res(
      ctx.data({
        updateMemberToConversation: {
          lastReadAt: "2021-03-18T09:49:35",
          notifications: "Never",
          user: {
            userName: "e10636@isdb.onmicrosoft.com",
          },
        },
      })
    );
  }),
];
